import { render, staticRenderFns } from "./ClassicAntimatterDimensionsTabHeader.vue?vue&type=template&id=bca6be54"
import script from "./ClassicAntimatterDimensionsTabHeader.vue?vue&type=script&lang=js"
export * from "./ClassicAntimatterDimensionsTabHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports